var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.b{clip-path:url(#a);}.c{stroke:#fff;stroke-miterlimit:10;stroke-width:4px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 64,
    height: 60,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0.228)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-0.001 -0.227)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 6.027,
    cy: 5.881,
    rx: 6.027,
    ry: 5.881,
    transform: "translate(26.119 3.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.818,14.877H1.133A28.3,28.3,0,0,0,3.745,26.733H19.2A55.021,55.021,0,0,1,17.818,14.877Z",
    transform: "translate(1.117 14.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.9,21H2.449A29.792,29.792,0,0,0,29.607,38.188v-1.7C24.482,36.49,20.057,30.178,17.9,21Z",
    transform: "translate(2.412 19.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M23.411,14.877A55.021,55.021,0,0,1,22.03,26.733H37.484A28.3,28.3,0,0,0,40.1,14.877Z",
    transform: "translate(21.692 14.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.133,36.49v1.7A29.792,29.792,0,0,0,43.291,21H27.836C25.683,30.178,21.257,36.49,16.133,36.49Z",
    transform: "translate(15.886 19.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M22.625,14.877H9.54a54.9,54.9,0,0,0,1.381,11.856h11.7Z",
    transform: "translate(9.394 14.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.236,21c2.153,9.178,6.579,15.49,11.7,15.49V21Z",
    transform: "translate(10.08 19.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.133,36.49c5.124,0,9.55-6.312,11.7-15.49h-11.7Z",
    transform: "translate(15.886 19.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.133,26.733h11.7a54.9,54.9,0,0,0,1.381-11.856H16.133Z",
    transform: "translate(15.886 14.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M21.908,8A11.765,11.765,0,0,0,10,19.618H33.815A11.765,11.765,0,0,0,21.908,8Z",
    transform: "translate(10.111 8.683)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 4.465,
    cy: 4.357,
    rx: 4.465,
    ry: 4.357,
    transform: "translate(48.392 9.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.931,9.5A8.825,8.825,0,0,0,22,18.213H39.862A8.825,8.825,0,0,0,30.931,9.5Z",
    transform: "translate(21.927 10.087)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 4.465,
    cy: 4.357,
    rx: 4.465,
    ry: 4.357,
    transform: "translate(6.715 9.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9.931,9.5A8.825,8.825,0,0,0,1,18.213H18.862A8.825,8.825,0,0,0,9.931,9.5Z",
    transform: "translate(1.25 10.087)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCulture);
export default __webpack_public_path__ + "static/media/icon_culture.4f5d8606360de41e3668d70c9cc0c529.svg";
export { ForwardRef as ReactComponent };